type NavigateOptions = { replace?: boolean }
type Navigate = (to: string, options?: NavigateOptions) => void

let mountedNavigate: Navigate | null = null
let pendingNavigation: { to: string; options?: NavigateOptions } | null = null

/**
 * Let the mounted router publish itself for callers that sit above it.
 *
 * `RouterProvider` is nested *inside* the jobs/notification provider, so that
 * provider cannot use `useNavigate()`. Rather than reload the page, it asks
 * here for whatever router is currently mounted.
 */
export function registerAppNavigate(navigate: Navigate): () => void {
  mountedNavigate = navigate
  if (pendingNavigation) {
    const { to, options } = pendingNavigation
    pendingNavigation = null
    try {
      navigate(to, options)
    } catch (err) {
      console.warn('Failed to replay pending navigation:', err)
    }
  }
  return () => {
    if (mountedNavigate === navigate) mountedNavigate = null
  }
}

/**
 * Navigate without a page reload. Returns false when no router is mounted, so
 * the caller can still fall back to a real navigation.
 */
export function navigateApp(to: string, options?: NavigateOptions): boolean {
  if (!mountedNavigate) {
    pendingNavigation = { to, options }
    return true
  }
  mountedNavigate(to, options)
  return true
}
